import { produce } from 'immer';
import { asyncAction } from './async-action';
import { ScopedAsyncType } from './scoped-type';
import * as api from '../../lib/api';

const initialState = {
  isLoading: false,
  error: null,
  fields: [],
};

const SLICE = 'productivity';
const asyncType = ScopedAsyncType(SLICE);

const LOAD_PRODUCTIVITY = asyncType('LOAD_PRODUCTIVITY');
const SET_APPROVAL = asyncType('SET_APPROVAL');

export const actions = {
  loadProductivity,
  setApproval,
};

function loadProductivity(growerId) {
  return asyncAction(LOAD_PRODUCTIVITY, () =>
    api.getProductivityForGrower(growerId),
  );
}

function setApproval(field, isApproved) {
  return asyncAction(
    SET_APPROVAL,
    () => api.setProductivityApproval(field.aaManagedId, isApproved),
    {
      startPayload: { field, isApproved },
      failurePayload: { field, isApproved },
    },
  );
}

const reducerHandlers = {
  [LOAD_PRODUCTIVITY.start]: (state) => {
    state.isLoading = true;
    state.error = null;
    state.fields = [];
  },
  [LOAD_PRODUCTIVITY.complete]: (state, payload) => {
    state.isLoading = false;
    state.fields = payload;
  },
  [LOAD_PRODUCTIVITY.failure]: (state, error) => {
    state.isLoading = false;
    state.error = error?.message || error;
  },
  [SET_APPROVAL.start]: (state, { field, isApproved }) => {
    state.fields.forEach((f) => {
      if (f.objectId === field.objectId) f.isApproved = isApproved;
    });
  },
  [SET_APPROVAL.failure]: (state, { field, isApproved }) => {
    state.fields.forEach((f) => {
      if (f.objectId === field.objectId) f.isApproved = !isApproved;
    });
  },
};

export const reducers = {
  [SLICE]: (state = initialState, { type, payload } = {}) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};
